var _defs, _path, _path2, _path3, _g, _use;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVe(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 512,
    width: 512,
    id: "flag-icon-css-ve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "d",
    transform: "translate(0 -36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-5L-1.545-.245l2.853.927z",
    id: "a",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "scale(-1 1)",
    width: 180,
    height: 120
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "rotate(72)",
    width: 180,
    height: 120
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "rotate(-72)",
    width: 180,
    height: 120
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(144)",
    width: 180,
    height: 120
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v512H0z",
    fill: "#cf142b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v341.335H0z",
    fill: "#00247d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v170.665H0z",
    fill: "#fc0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f",
    transform: "translate(256.335 358.4) scale(4.265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("use", {
    height: 120,
    width: 180,
    transform: "rotate(10)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    height: 120,
    width: 180,
    transform: "rotate(30)",
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("use", {
    height: 120,
    width: 180,
    transform: "rotate(40)",
    xlinkHref: "#e"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    height: 120,
    width: 180,
    transform: "rotate(-80 256.335 358.4)",
    xlinkHref: "#f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVe);
export default __webpack_public_path__ + "static/media/ve.3a0ada183ef2e1cf48b000551cde390c.svg";
export { ForwardRef as ReactComponent };